module.exports = __webpack_public_path__ + "img/icon_01.4d73996.png";